"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InputLabel = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
exports.InputLabel = styled_components_1.default.label `
  display: block;
  font-weight: bold;
  font-size: 12px;
  margin-bottom: 5px;
`;
//# sourceMappingURL=input-label.js.map